
import React, { useState } from 'react';
import './AdminLogin.css';
import bannerImage from '../../assets/download.webp'
import { User, Lock } from 'lucide-react';

function AdminLogin({ onLoginSuccess }) {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const validUsername = 'yogii6';
    const validEmail = 'yogesh6@gmail.com';
    const validPassword = 'yogii@6';

    const isValid =
      (identifier === validUsername || identifier === validEmail) &&
      password === validPassword;

    if (isValid) {
      onLoginSuccess();
    } else {
      setError('Invalid username/email or password');
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-wrapper">
        <div className="admin-login-banner">
          <img src={bannerImage} alt="Banner" />
        </div>
        <div className="admin-login-box">
          <h2 className="login-title">Admin Login</h2>
          {error && <p className="login-error">{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <User className="input-icon" size={20} />
              <input
                type="text"
                placeholder="Username or Email"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <Lock className="input-icon" size={20} />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="login-btn">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
